import { useLocalStorage } from "@vueuse/core";
import Session from "Session";
import { computed } from "vue";
export const useDeveloperMode = () => {
    const developerMode = useLocalStorage("extole.me.developerMode", false);
    return {
        developerMode,
    };
};
export const useMeClientId = () => {
    const clientId = computed(() => {
        return Session.getInstance().getClientId();
    });
    return {
        clientId,
    };
};
